<tt-page *ngIf="!!page">
    <ng-container *ngIf="tabletSize.matches; else mobileView">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-6 p-5">
                <tt-page-heading
                    *ngIf="p2WebpageKeyno === '0'"
                    ttModel="h_p2webpage_new"
                    ttTranslate>
                </tt-page-heading>
                <tt-page-heading
                    *ngIf="p2WebpageKeyno !== '0'"
                    ttModel="h_p2webpage_edit"
                    ttTranslate>
                </tt-page-heading>
                <div class="k-hr col-xs-12 sp-0"></div>
                <ng-container *ngTemplateOutlet="webpageFields"></ng-container>
            </tt-card>

            <tt-card *ngIf="!!p2WebpageKeyno" class="col-xs-12 col-md-6 p-5">
                <tt-page-heading ttModel="h_functions" ttTranslate></tt-page-heading>
                <div class="k-hr col-xs-12 sp-0"></div>
                <ng-container *ngTemplateOutlet="webpageActions"></ng-container>
            </tt-card>
        </div>
    </ng-container>

    <ng-template #mobileView>
        <tt-card class="col-xs-12 sp-0">
            <ng-container *ngTemplateOutlet="webpageFields"></ng-container>
            <ng-container *ngTemplateOutlet="webpageActions"></ng-container>
        </tt-card>
    </ng-template>

    <ng-template #webpageFields>
        <tt-input ttLabel="p2_webpage_keyno" [ttModel]="page.p2_webpage_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="webpage_name" [(ttModel)]="page!.webpage_name"></tt-input>
        <tt-input ttLabel="word_id" [(ttModel)]="page!.word_id"></tt-input>
        <tt-button-save [ttLocked]="lockedSave" (ttClick)="saveChanges()"></tt-button-save>
    </ng-template>

    <ng-template #webpageActions>
        <tt-button-goto
            ttText="webpage_link"
            [ttBadge]="page.subpages"
            ttGoto="webpagelink"
            [ttGotoParms]="{ p2_webpage_keyno: page.p2_webpage_keyno }">
        </tt-button-goto>
        <tt-button-goto
            ttText="p2_webpage_setting"
            ttGoto="webpagesetting"
            [ttGotoParms]="{ argtype: 'p2_webpage_keyno', argvalue: page.p2_webpage_keyno }">
        </tt-button-goto>
        <tt-button-goto
            ttText="p2_webpage_table_from_webpage"
            ttGoto="p2webpagetable"
            [ttGotoParms]="{ argtype: 'p2_webpage_keyno', argvalue: page.p2_webpage_keyno }">
        </tt-button-goto>
        <tt-button-goto
            ttText="p2webpageedit_subscriptions"
            ttGoto="webpagesubscription"
            [ttGotoParms]="{ argtype: 'p2_webpage_keyno', argvalue: page.p2_webpage_keyno }">
        </tt-button-goto>
    </ng-template>
</tt-page>
